import * as Device from "expo-device";
import * as Sentry from "@sentry/react-native";
import Purchases, { LOG_LEVEL } from "react-native-purchases";

import EnvironmentVariablesLoader from "@/utils/environment";
import type { AppUserSession } from "@/schemas/auth/session";

export async function setupRevenueCat(
  session: AppUserSession | null,
): Promise<void> {
  try {
    Purchases.setLogLevel(LOG_LEVEL.ERROR);
    const envVariables = EnvironmentVariablesLoader.getEnvironmentVariables();
    const apiKey =
      Device.osName?.toLowerCase() === "ios"
        ? envVariables.revenueCat.iosPublicKey
        : envVariables.revenueCat.androidPublicKey;

    // This is pre-registration for RevenueCat.
    if (session !== null) {
      Purchases.configure({
        apiKey: apiKey,
        appUserID: session.identity.username,
      });
    } else {
      Purchases.configure({
        apiKey: apiKey,
      });
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
